export const getters = {
    election(state) {
        return state.election;
    },
    yearList(state) {
        return state.yearList;
    },
    electionList(state) {
        return state.electionList;
    },
    contestList(state) {
        return state.contestList;
    },
    contest(state) {
        return state.contest;
    },
    candidateList(state) {
        return state.candidateList;
    },
    contestId(state) {
        return state.selectedContest;
    },
    user(state) {
        return state.user;
    },
    isAuthenticated(state) {
        return state.user ? true : false;
    },
    selectedContestId(state) {
        return state.selectedContest;
    },
    candidateStatementInfo(state) {
        return state.candidateStatementInfo;
    },
    year(state) {
        return state.year;
    },
    search(state) {
        return state.search;
    },
    filteredContestList(state) {
        if (!state.search) return state.contestList;
        const contestList = JSON.parse(JSON.stringify(state.contestList));            
        const input = state.search.trim().toUpperCase();
        const words = input.split(" ");
        let filteredList =  contestList.filter(c => {
            if (c.title.toUpperCase().indexOf(input) > -1) return true;
            let containsInput = false; 
            let matchingCandidates = c.candidates.filter(candidate => {
                const name = `${candidate.nameFirst} ${candidate.nameLast} ${candidate.nameMiddle}`;
                if (words.every((word) => name.indexOf(word) > -1)) {
                    containsInput = true;
                    return true;
                }
            })
            if (containsInput) {
                c.candidates = matchingCandidates;
            }
            return containsInput;
        });
        return filteredList;
    }
}